export const about = [
    {
      title: "Systems Analyst & Technical Support Engineer",
      company: "Extra Card",
      duration: "May 2022 - May 2023",
      description: "IT support, software rollouts, troubleshoot bugs & errors",
      icon: "/assets/about/laptop.png",
    },
    {
      title: "Loan Advocate & QA Engineer Apprentice",
      company: "OppFi",
      duration: "September 2018 - July 2021",
      description: "Technical support and quality assurance",
      icon: "/assets/about/travel-agent.png",
    },
    {
      title: "Illinois State University",
      duration: "2009-2012",
      description: "B.S. in Political Science & Economics",
      icon: "/assets/about/graduation.png",
    },
  ];